import { inject, Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Resolve, Router } from '@angular/router';
import { BackendErrorType } from '../errors/backend.errors';
import { BackendService } from '../backend.service';
import { CorporateDesignService } from '../corporate-design.service';
import { LandingpageConfiguration } from 'app/shared/models/landingpage-configuration.model';

@Injectable({
  providedIn: 'root',
})
export class LandingpageConfigurationStateService implements Resolve<LandingpageConfiguration> {
  private backendService = inject(BackendService);
  private logger = inject(NGXLogger);
  private corporateDesignService = inject(CorporateDesignService);
  private router = inject(Router);

  private config: LandingpageConfiguration | undefined;

  resolve(): Promise<LandingpageConfiguration> {
    return new Promise((resolve, reject) => {
      this.landingpageConfig().then(
        (landingpageConfig) => {
          resolve(landingpageConfig);
        },
        (error) => {
          if (error.message === BackendErrorType.ALREADY_SENT) {
            this.router.navigate(['already-sent']);
          } else {
            this.router.navigate(['']);
          }
          reject('No session found');
        },
      );
    });
  }

  landingpageConfig(): Promise<LandingpageConfiguration> {
    if (this.config != undefined && this.config != null) {
      return new Promise((resolve) => resolve(this.config!));
    }

    const token = sessionStorage.getItem('landingpageAccessToken');
    if (token != undefined && token != null) {
      return this.reloadConfig(token);
    }

    return new Promise((_resolve, reject) => {
      reject('No session found');
    });
  }

  updateConfig(newConfig: LandingpageConfiguration, token: string) {
    sessionStorage.setItem('landingpageAccessToken', token);
    this.config = newConfig;
  }

  reloadConfig(token: string): Promise<LandingpageConfiguration> {
    return new Promise((resolve, reject) => {
      this.backendService.submitPersonalAccessToken(token).subscribe({
        next: (response) => {
          this.logger.debug('Request Landingpage Configuration:', {
            requestParam: token,
            response: response,
          });
          this.updateConfig(response, token);

          //add orga specific colors, (fav)icons and fonts
          this.corporateDesignService.updateTheme(response.organisation.corporateDesign, response.assetBucketUrl);
          resolve(response);
        },
        error: () => {
          sessionStorage.clear();
          reject('No Session found');
        },
      });
    });
  }
}
